import { localDate as _localDate } from "./date-fns/localDate";

/**
 * @deprecated use {@link intlDate} from "@faire/web--source/common/localization/date-fns/intlDate"
 */
export const localDate = _localDate;
